import { OrderingInitialState, SetDescriptionAction } from '@reducers/ordering/types';

export const setDescription = (state: OrderingInitialState, action: SetDescriptionAction): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    description: action.payload.description,
  },
});
